module.exports = __webpack_public_path__ + "img/about_con_2-3.3f93bf15.png";